export default {
  install(Vue) {
    // 防重复点击(指令实现)
    Vue.directive("preventRepeat", {
      inserted(el, binding) {
        function __avoidRepeatHandler__() {
          if (el.__clickDisabled__) return;

          el.__clickDisabled__ = true;
          el.__originalPointerEvents__ = el.style.pointerEvents;
          el.style.pointerEvents = "none";
          setTimeout(() => {
            el.__clickDisabled__ = false;
            el.style.pointerEvents = el.__originalPointerEvents__;
          }, binding.value || 1000);
        }
        el.addEventListener("click", __avoidRepeatHandler__);
        el.__avoidRepeatHandler__ = __avoidRepeatHandler__;
      },
      unbind(el) {
        el.removeEventListener("click", el.__avoidRepeatHandler__);
        delete el.__clickDisabled__;
        delete el.__originalPointerEvents__;
      },
    }),
      /**
       * direction:{top:false,left:false,dragClass:null}
       * top:支持上下拖动
       * left:支持左右拖动
       * dragClass:指定可以拖动盒子的 className
       */
      //拖拽
      Vue.directive("drag", {
        // 指令的定义
        bind: function (el, direction) {
          // console.log(el);
          let oDiv = el; // 获取当前元素
          oDiv.onmousedown = (e) => {
            // console.log(e);
            let dir = direction.value || {
              top: true,
              left: true,
              dragClass: "",
            };
            if (
              !dir.dragClass ||
              e.target.className.indexOf(dir.dragClass) !== -1
            ) {
              // 算出鼠标相对元素的位置
              let disX = e.clientX - oDiv.offsetLeft;
              let disY = e.clientY - oDiv.offsetTop;
              document.onmousemove = (e) => {
                // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;
                let top = e.clientY - disY;
                if (dir.top && top > 0) {
                  oDiv.style.top = top + "px";
                }
                if (dir.left) {
                  oDiv.style.left = left + "px";
                }
              };
              document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
              };
            }
          };
        },
      });
    // 数据大于 9999 以万为单位显示
    Vue.filter("formatNumber", function (number) {
      if (number) {
        if (number > 9999) {
          let num = (number / 10000).toFixed(1);
          return num + "万";
        } else {
          return number;
        }
      } else {
        return 0;
      }
    });

    Vue.filter("hourMinuteSecond", function (value) {
      let hour = 0;
      let min = 0;
      let sec = 0;
      let data = null;
      if (value < 60) {
        data = "00:" + (value > 9 ? value : "0" + value);
      } else if (value >= 60 && value < 3600) {
        min = parseInt(value / 60);
        sec = value % 60;
        data = (min > 9 ? min : "0" + min) + ":" + (sec > 9 ? sec : "0" + sec);
      } else if (value >= 3600) {
        min = parseInt(value / 60);
        hour = parseInt(min / 60);
        min = min % 60;
        sec = sec % 60;
        data =
          (hour > 9 ? hour : "0" + hour) +
          ":" +
          (min > 9 ? min : "0" + min) +
          ":" +
          (sec > 9 ? sec : "0" + sec);
      }
      return data;
    });
  },
};
